import React from 'react'
import IntercomContactSyncIntegrationV2 from '.'
import * as R from 'ramda'

import toast from 'libs/toast'
import useSaveUserActivityLog, { ACTION_NAME } from 'hooks/useSaveUserActivityLog'
import useAxios, { mutate } from 'hooks/useAxios'

export default function IntercomContactSyncIntegrationV2Container() {
  const intercomCredentialAxiosResult = useAxios({
    url: 'intercom/authentication/',
  })
  const authenticateIntercomAxiosResult = useAxios({
    url: 'intercom/authentication/',
    method: 'post',
    skip: true,
  })
  const revokeIntercomAccessAxiosResult = useAxios({
    method: 'delete',
    url: 'intercom/authentication/',
    skip: true,
  })
  const toggleIntercomCustomersSyncAxiosResult = useAxios({
    method: 'patch',
    url: 'intercom/trigger-sync-customer/',
    skip: true,
  })

  const saveUserActivityLog = useSaveUserActivityLog()

  function handleToggleCustomersSync() {
    const isEnable = !intercomCredentialAxiosResult.data.is_enable_customer_sync
    const action = ACTION_NAME.connected_intercom

    const data = { enable: isEnable, integration: 'customer_sync' }
    toggleIntercomCustomersSyncAxiosResult
      .fetch({
        data,
      })
      .then(() => {
        mutate('intercom/authentication/')
        if (isEnable) {
          toast.success('Integration activated!')
        } else {
          toast.success('Integration deactivated.')
        }
        saveUserActivityLog({
          action,
          target: 'intercom_credential',
          requestBody: data,
          statusCode: 200,
        })
      })
      .catch((error) => {
        toast.error(
          'Oops! Something went wrong. Please try again or contact Simplesat support for help.'
        )
        saveUserActivityLog({
          action,
          target: 'intercom_credential',
          requestBody: data,
          errorResponseBody: data,
          statusCode: error.status,
        })
      })
  }

  return (
    <React.Fragment>
      <IntercomContactSyncIntegrationV2
        syncButtonLoading={
          (!intercomCredentialAxiosResult.data && intercomCredentialAxiosResult.loading) ||
          toggleIntercomCustomersSyncAxiosResult.loading ||
          authenticateIntercomAxiosResult.loading ||
          revokeIntercomAccessAxiosResult.loading
        }
        isContactSyncEnabled={R.prop('is_enable_customer_sync')(intercomCredentialAxiosResult.data)}
        isAuthenticated={Boolean(intercomCredentialAxiosResult.data)}
        toggleCustomersSync={handleToggleCustomersSync}
      />
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/IntercomContactSyncIntegrationV2/container.js